/** Soft-delete board assets no longer referenced in scene (fire-and-forget). */
export async function markAssetsDeleted(opts: {
  boardId: string;
  assetIds: string[];
  shareToken?: string | null;
  guestEditKey?: string | null;
  useCredentials: boolean;
}): Promise<void> {
  const unique = [...new Set(opts.assetIds.filter(Boolean))];
  if (!unique.length) return;

  let url = "/api/v1/assets/mark-deleted";
  if (opts.shareToken) url += `?t=${encodeURIComponent(opts.shareToken)}`;
  else if (opts.guestEditKey) url += `?k=${encodeURIComponent(opts.guestEditKey)}`;

  await fetch(url, {
    method: "POST",
    credentials: opts.useCredentials ? "include" : "omit",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      boardId: opts.boardId,
      assetIds: unique,
      shareToken: opts.shareToken ?? undefined,
    }),
  }).catch(() => {});
}

export function collectPdfAssetIds(obj: {
  type?: string;
  sourceAssetId?: unknown;
  pageAssetIds?: unknown;
}): string[] {
  if (obj.type !== "pdf_document") return [];
  const ids: string[] = [];
  if (typeof obj.sourceAssetId === "string") ids.push(obj.sourceAssetId);
  if (Array.isArray(obj.pageAssetIds)) {
    for (const id of obj.pageAssetIds) {
      if (typeof id === "string") ids.push(id);
    }
  }
  return ids;
}

export function collectMediaAssetIds(obj: {
  type?: string;
  assetId?: unknown;
  sourceAssetId?: unknown;
  pageAssetIds?: unknown;
}): string[] {
  if (obj.type === "audio" || obj.type === "image") {
    return typeof obj.assetId === "string" ? [obj.assetId] : [];
  }
  return collectPdfAssetIds(obj);
}
